// 016B — Curvas de Crecimiento de Fenton, niños (Fase 5, Tanda 3, ver PLAN.md).
// Mismo estándar Fenton 2013 y mismos datos que 028A-1 (que empaqueta las
// láminas de niños y niñas en un solo formulario): el sexo del paciente ya
// decide el dataset en `paciente/curvaPercentilPorEdad.ts`, así que esto es
// solo otra fachada de captura (peso/longitud/perímetro cefálico + edad
// gestacional REQUERIDA, sin ella Fenton no tiene eje X) — mismo criterio que
// 028B-1/028B-2. Las Observation son las mismas que las de 028A-1 y alimentan
// la misma curva.
import { crearFormularioCurvaCrecimiento } from './curvaCrecimiento';

export const Formulario016B = crearFormularioCurvaCrecimiento({
  claveI18n: 'f016b',
  codigo: '016B',
  incluirPerimetroCefalico: true,
  incluirEdadGestacionalAlNacer: 'requerido',
  curvasPdf: 'fenton',
});
